import ListResultCountLabel from './ListResultCountLabel'

export default ListResultCountLabel
